import React from 'react';
import { motion } from 'framer-motion';

const Differentiator = () => {
  const scrollToForm = () => {
    document.getElementById('lead-form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-32 bg-limestone-warm relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          <motion.div 
            className="lg:w-1/2 relative"
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <div className="absolute -inset-4 border border-antique-gold/20 rounded-lg -z-10 translate-x-2 translate-y-2"></div>
            <div className="aspect-[4/3] rounded-lg overflow-hidden shadow-2xl">
              <div className="w-full h-full bg-differentiator-pattern bg-cover bg-center transition-transform duration-700 hover:scale-105"></div>
            </div>
          </motion.div>

          <motion.div 
            className="lg:w-1/2 lg:pl-12"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-olive-sage font-sans font-semibold uppercase tracking-[0.2em] text-xs mb-4 block">The Setting</span>
            <h2 className="font-serif text-4xl md:text-5xl text-mission-green mb-8">
              Not Another Hotel Ballroom
            </h2>
            <p className="text-mission-green/80 text-lg leading-relaxed mb-6">
              Your company worked too hard this year to end it in a room that feels like every other event. Padua Weddings offers a warm, historic, Spanish Revival atmosphere that makes the evening feel more personal, elevated, and memorable.
            </p>
            <p className="text-mission-green/80 text-lg leading-relaxed mb-10">
              Located in Claremont, we provide an exclusive oasis away from the standard corporate spaces, setting the perfect tone for a genuine celebration.
            </p>
            <button 
              onClick={scrollToForm}
              className="px-10 py-4 bg-mission-green text-spanish-ivory font-semibold rounded hover:bg-antique-gold hover:text-mission-dark transition-all duration-300 uppercase tracking-widest text-sm shadow-lg"
            >
              See December Dates
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Differentiator;